import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../../settings-action-id.constants';
import * as Actions from '../evidence-list.actions';
import {GRID_FILTER_TOGGLE} from "../../../../../common/grid/grid.constants";
import {getDocFileNameFromPath} from "../../../../../common/utils/util.path";

class EvidenceImportsGridController extends GridController {
    constructor($ngRedux, $state, $stateParams, NavigationService, AuthService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accSettings;
        this.statePath = IDS.evidenceImportsGrid;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        // this.autoload = false;
        this.icon = false;

        this.$ngRedux.dispatch({
            type: GRID_FILTER_TOGGLE,
            id: IDS.accSettings,
            path: IDS.evidenceImportsGrid,
            filter: {
                scheme_code: this.$stateParams.itemCode
            }
        });

        this.isAdmin = this.AuthService.getUser().type === 'Administrator';

        const getFileName = (item) => {
            const filename = getDocFileNameFromPath(item.import_file_uri);
            // remove timestamp prefix
            return filename ? filename.substring(filename.indexOf('-') + 1) : '';
        }

        this.columnsDefault = [
            {title: '#',                                                            mapper: null},
            {title: this.$filter('translate')(`COMMON.FIELD.CREATED`),              mapper: 'started'},
            {title: this.$filter('translate')(`COMMON.FIELD.HEAD_OFFICE`),          mapper: 'location'},
            {title: this.$filter('translate')(`COMMON.FIELD.FILENAME`),             mapper: getFileName},
            {title: this.$filter('translate')(`COMMON.FIELD.AUTHOR`),               mapper: 'issuer'},
        ];
        this.columns = this.columnsDefault.concat();

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);

        this.dataAction = this.fetchHofRequiredDocsImportsGrid;

        this.buttons.push({
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event);
            },
            filter: item => {
                return item.import_file_uri
            },
        });
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

EvidenceImportsGridController.$inject = ['$ngRedux', '$state', '$stateParams', 'NavigationService', 'AuthService', '$filter', '$mdDialog', '$scope'];

export const evidenceImportsGrid = {
    bindings: {
        onSelect: '&',
        onDownload: '&',
    },
    controller: EvidenceImportsGridController,
    ...gridTpl
}
